<div class="panel">
    <h1 mat-dialog-title>
        {{data.title}}
    </h1>

    <div mat-dialog-content>
        <p>{{data.message}}</p>
    </div>

    <div mat-dialog-actions>

        <button class="m-r-15" mat-raised-button color="accent" (click)="onClose()">OK</button>

    </div>
</div>